import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBInputGroup,
  MDBDatepicker,
  MDBSelect,
  MDBDatatable,
  MDBIcon, MDBTextArea,
  MDBPopconfirm, MDBPopconfirmMessage,
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,
  MDBBadge, MDBTable, MDBTableHead, MDBTableBody

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import Favoriteitem from './sub/favoriteitem'
import Billlist from './sub/billlist'
import { v4 as uuidv4 } from 'uuid';


const Component = () => {

  const { state } = useLocation();
  let { name } = useParams();
  const error = useRef();
  const setError = (message) => error.current.showerror(message);

  const editjob = useRef();
  const [isTransport, setIsTransport] = useState(false);
  const [isFinalize, setIsFinalize] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);

  const [selectedrow, setSelectedRow] = useState(null);
  const [summarydata, setSummarydata] = useState({});
  const [transportAccount, setTransportAccount] = useState({});
  const [billlist, setBilllist] = useState({ bills: [] });
  const [billitem, setBillitem] = useState([]);
  const [selectpaidby, setselectpaidby] = useState(1);
  const [customers, setCustomers] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState();
  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getCustomers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setCustomers([{ text: '', value: 0 }, ...data.Customers]);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch customers');
      }
    } catch (err) {
      setError('An error occurred while fetching customers.');
    }
  };

  const [paidbylist, setpaidbylist] = useState([
    { text: 'บริษัท', value: 1 },
    { text: 'เครดิต', value: 2 },
    { text: 'เงินสด', value: 3 }
  ]);
  const approve = async (e) => {
    e.preventDefault();
    if (billlist.bills.length == 0) { setError("ไม่มีข้อมูล"); return; }
    if (!transportAccount.customerid) { setError("ไม่มีข้อมูลลูกค้า"); return; }
    setIsLoading(true);
    try {
      transportAccount.duedate = document.getElementById("duedate").value;
      transportAccount.billdate = document.getElementById("billdate").value;
      transportAccount.remark = document.getElementById("remark").value;
      transportAccount.summarydata = summarydata;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransportAccount_expense`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportAccount, billlist, approve: true }),
      });
      const data = await response.json();
      if (response.ok) {
        setTransportAccount(data.transportAccount_expense);
        setBilllist({ bills: [...data.expense] });

        error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
        setIsFinalize(data.transportAccount_expense.statusid == 3 ? true : false);
      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }
  }

  const saveData = async (e) => {
    e.preventDefault();
    if (billlist.bills.length == 0) { setError("ไม่มีข้อมูล"); return; }
    if (billlist.bills.filter(e => e.totalamount > 0).length == 0) { setError("ไม่มีข้อมูล"); return; }
    if (!transportAccount.customerid) { setError("ไม่มีข้อมูลลูกค้า"); return; }
    setIsLoading(true);
    try {

      transportAccount.duedate = document.getElementById("duedate").value;
      transportAccount.billdate = document.getElementById("billdate").value;
      transportAccount.receipt_date = document.getElementById("receipt_date").value;
      transportAccount.remark = document.getElementById("remark").value;
      transportAccount.summarydata = summarydata;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransportAccount_expense`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportAccount, billlist }),
      });
      const data = await response.json();
      if (response.ok) {
        setTransportAccount(data.transportAccount_expense);
        setBilllist({ bills: [...data.expense] });

        error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }

  }
  const navigate = useNavigate();

  const getTransportAccount_expense = async (transportname) => {

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccount_expense/${transportname}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (!data.transportAccount) {
          setError('ไม่มีข้อมูลการขนส่ง');
          return;
        }

        setSummarydata({
          totalamount: data.transportAccount.totalamount,
          totalnetamount: data.transportAccount.totalnetamount,
          totalvatamount: data.transportAccount.totalvatamount,
          totalwhtamount: data.transportAccount.totalwhtamount,
          totalpaidamount: data.transportAccount.totalpaidamount
        });
        if (data.transportAccount?.transportid) {
          setIsTransport(true);
        }
        setTransportAccount(data.transportAccount);
        setBilllist({ bills: [...data.expense] });
        setSelectCustomer(data.transportAccount.customerid);
        setIsFinalize(data.transportAccount.statusid == 3);
        getBillitem();
        //setselectpaidby(data.transportAccount.paidbyid)
        // getBilllist(data.transportAccount.id);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }



  const getBillitem = async () => {


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getBillitem`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setBillitem(data.result);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }

  useEffect(() => {
    // Get the token from sessionStorage


    if (!["accountant", "billing", "admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    name && getTransportAccount_expense(name);

    fetchCustomers();


  }, []);
  const addduedate = (duration) => {
    var currentduedate = document.getElementById("billdate").value;
    currentduedate = moment(currentduedate, "DD/MM/YYYY").add(duration, "days");
    document.getElementById("duedate").value = currentduedate.format("DD/MM/YYYY");
  }

  const endEdit = () => {



  }
  const editRow = (row) => {

    setBasicModal(true);
    setSelectedRow({ row });

  }
  const deleteRow = (row) => {



  }

  const unapprove = async () => {


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/revertTransportAccount_expense/${transportAccount.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        transportAccount.statusid == 2
        setIsFinalize(false);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }

  const updatesummary = (bills) => {
    var summarydata = { totalamount: 0, totalwhtamount: 0, totalvatamount: 0 }

    billlist.bills.forEach(bill => {

      summarydata.totalamount += parseFloat(bill.totalamount ? bill.totalamount : 0);
      summarydata.totalwhtamount += parseFloat(bill.whtamount ? bill.whtamount : 0);
      summarydata.totalvatamount += parseFloat(bill.vatamount ? bill.vatamount : 0);
    });


    summarydata.totalnetamount = summarydata.totalvatamount + summarydata.totalamount;
    summarydata.totalpaidamount = summarydata.totalnetamount - summarydata.totalwhtamount;

    setSummarydata(summarydata);
  }




  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={error} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='6'>
                  <h4>{ transportAccount.name?`ข้อมูลบันทึกค่าใช้จ่าย (${transportAccount.name} - วันที่เอกสาร ${moment(transportAccount?.jobdateobj).format('DD/MM/YYYY  HH:mm')})`:"ลงข้อมูลบันทึกค่าใช้จ่าย"}</h4>
                </MDBCol>
                <MDBCol md={isTransport ? 3 : (isFinalize ? 6 : 4)}>
                  <div className='d-flex flex-row-reverse me-3'>
                    {!isFinalize && !isTransport && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={() => window.open(`/Print/Expense/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ใบวางบิล</MDBBtn>
                    </div>}
                    
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={() => window.open(`/Print/ExpenseTawi50/` + transportAccount.name + '?personal=1', '_blank')} disabled={isLoading}>พิมพ์ทวิ50 (บุคคล)</MDBBtn>
                    </div>
                    {!isTransport && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={() => window.open(`/Print/ExpenseTawi50/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ทวิ50</MDBBtn>
                    </div>}


                    {isFinalize && !isTransport && ["billing", "admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={() => window.open(`/Print/ExpenseReceipt/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ใบแจ้งหนี้</MDBBtn>
                    </div>}
                  </div>
                </MDBCol>
                <MDBCol md={isTransport ? 2 : 1}>

                  {!isFinalize && !isTransport && ["billing", "admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='success' onClick={approve} disabled={isLoading}>อนุมัติ</MDBBtn>
                  </div>}
                  {isFinalize && !isTransport && ["admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='danger' onClick={unapprove} disabled={isLoading}>ยกเลิกอนุมัติ</MDBBtn>
                  </div>}
                  {isTransport && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                    <MDBBtn rounded size='lg' color='success' onClick={() => window.open(`/TransportAccount/` + transportAccount.transportname, '_blank')} disabled={isLoading}>แก้ไขข้อมูลบัญชีขนส่ง</MDBBtn>
                  </div>}
                </MDBCol>
                <MDBCol md='1'>

                  {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
                  </div>}
                </MDBCol>
              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>
              <MDBRow className="mt-3">
                <MDBCol md="5">
                  <MDBInputGroup textBefore='ลูกค้า' className='mb-3 dropdown-group'>
                    <MDBSelect
                      search
                      disabled={isTransport || isFinalize}
                      data={customers}
                      displayValue={(row) => row.name}
                      label='เลือกลูกค้า'
                      value={selectCustomer}
                      onChange={(e) => {
                        if (!e) return;
                        if (e.value === 0) {
                          setSelectCustomer(0);
                          document.getElementById("tax").value = '';
                          return;
                        }
                        setSelectCustomer(e.value);
                        const selectedCustomer = customers.find(customer => customer.value === e.value);
                        if (selectedCustomer) {
                          transportAccount.customerid = selectedCustomer.value;
                          transportAccount.customername = selectedCustomer.text;
                          transportAccount.tax = selectedCustomer.tax;
                          document.getElementById("tax").value = selectedCustomer.tax || '';
                        }
                      }}
                    />

                    <span className='input-group-text'>เลขภาษี</span>
                    <input className='form-control' type='text' id="tax" readOnly />
                  </MDBInputGroup>
                </MDBCol>
                <MDBCol md="2">

                  <MDBInputGroup textBefore='วันที่ชำระ' className='mb-3 dropdown-group'>
                    <MDBDatepicker inputToggle inline id={"receipt_date"} inputLabel="วันที่ชำระ" onChange={(value) => transportAccount.receipt_date = value} value={transportAccount?.receipt_date ? transportAccount?.receipt_date : (transportAccount?.receipt_dateobj ? moment(transportAccount?.receipt_dateobj).format('DD/MM/YYYY') : "")} />

                  </MDBInputGroup>

                </MDBCol>

                <MDBCol md="5">

                  <MDBInputGroup textBefore='วันที่ออก' className='mb-3 dropdown-group'>
                    <MDBDatepicker inputToggle inline id={"billdate"} inputLabel="วันที่ออก" onChange={(value) => transportAccount.billdate = value} value={transportAccount?.billdate ? transportAccount?.billdate : (transportAccount?.billdateobj ? moment(transportAccount?.billdateobj).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'))} />
                    <span className='input-group-text'>วันครบกำหนด</span>
                    <MDBDatepicker inputToggle inline id={"duedate"} inputLabel="วันครบกำหนด" onChange={(value) => { transportAccount.duedate = value }} value={transportAccount?.duedate ? transportAccount?.duedate : (transportAccount?.duedateobj ? moment(transportAccount?.duedateobj).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'))} />
                    <MDBBtn outline color='dark' onClick={() => addduedate(3)}>+3 วัน</MDBBtn>
                    <MDBBtn outline color='dark' onClick={() => addduedate(7)}>+7 วัน</MDBBtn>
                    <MDBBtn outline color='dark' onClick={() => addduedate(30)}>+30 วัน</MDBBtn>
                  </MDBInputGroup>

                </MDBCol>
                <MDBCol md="12">
                  <MDBTextArea
                    label="หมายเหตุ"
                    id={"remark"}
                    name="remark"
                    defaultValue={transportAccount.remark}
                    className="mb-3"
                    rows={2}
                  />
                </MDBCol>
                <MDBCol md="12">

                  <MDBInputGroup textBefore='สรุป' className='mb-3 '>
                    <span className='input-group-text'>มูลค่าไม่รวมภาษี {summarydata?.totalamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'>จำนวนเงินที่ถูกหัก ณ ที่จ่าย {summarydata?.totalwhtamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'>จำนวนเงินที่ชำระ  {summarydata?.totalpaidamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'><b>จำนวนเงินทั้งสิ้น  {summarydata?.totalnetamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</b></span>

                  </MDBInputGroup>

                </MDBCol>

                {/* {billitem && billitem.length > 0 && billitem.filter(e => e.canaddtoall == 1).map((item, i) => (<Favoriteitem key={i} item={item} callback={addtoall} />))}
                 */}
              </MDBRow>
              <div className='d-flex align-items-center h-100 mb-2'>

                {<Billlist Row={billlist} key={"billgrid"} index={"billgrid"} items={billitem} updateparent={updatesummary} isexpense={true} isReadOnly={isFinalize || isTransport} />}

              </div>
              {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
              </div>}
            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>




      <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
        <MDBModalDialog centered size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>แก้ไขข้อมูลงาน</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {selectedrow && <JobDetail setError={setError} customers={customers} ref={editjob} job={selectedrow.row} mode="edit" disabledCustomer={billlist.length > 0} />}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleOpen}>
                ปิด
              </MDBBtn>
              <MDBBtn onClick={endEdit}>บันทึก</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>
  </>
  );
};

export default Component;
